const formattedDate = (date) => {
  const dateFormatted = new Date(date);
  return dateFormatted.toLocaleDateString('pt-BR');
}

export default formattedDate;